exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.app-content.is-visible{opacity:1;transition:opacity 1s ease-in}.app-content{opacity:0;width:800px;height:600px;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.app-count{color:#7f7f7f}.app-count,.app-videoLink{text-align:center;position:relative;top:-25px;font-family:Lucida Console;font-size:18px}.app-videoLink a:link,.app-videoLink a:visited{color:#7f7f7f;transition:color .25s ease-out}.app-videoLink a:active,.app-videoLink a:hover{color:#b3b3b3}.angel{width:50px;height:50px;background-size:contain;z-index:20000;overflow:hidden;transform:translate(50px,50px);transition:transform 5s;margin-top:-10px}.angel,.angel:before{position:absolute;left:0;top:0}.angel:before{content:\"\";width:200px;height:575px;background:url(\"assets/i/angel.png\") no-repeat;background-size:contain}.angel.is-frame1:before{left:0}.angel.is-frame2:before{left:-50px}.angel.is-frame3:before{left:-100px}.angel.is-frame4:before{left:-150px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?-url!./~/resolve-url-loader!./~/sass-loader!./~/postcss-loader!./src/client/panorama/index.scss
 ** module id = 16
 ** module chunks = 2
 **/